import { createFileRoute } from '@tanstack/react-router'
import { ProfilePending } from '../../../app/route-states'
import { DsrDetailPage } from '../../../features/privacy/dsr-detail-page'
import { dsrQueryOptions } from '../../../features/privacy/queries'

export const Route = createFileRoute('/_app/privacy-requests/$requestId')({
  staticData: { crumb: 'privacyRequest' },
  loader: ({ context, params }) => context.queryClient.ensureQueryData(dsrQueryOptions(params.requestId)),
  pendingComponent: ProfilePending,
  component: DsrDetailPage,
})
